import { Button } from '@/atoms';
import { Blok } from '@/bloks/Blok';
import { OffertaPopUpButtonStoryblok } from '@/components';
import { useOffertaModal } from '@/contexts/offerta-modal/OffertaModalProvider';
import { getPiwikTrackingSlug } from '@/trackers/piwik';
import { usePiwikPro } from '@piwikpro/next-piwik-pro';
import { usePathname } from 'next/navigation';
import React, { useEffect } from 'react';
import styles from './OffertaPopUpButton.module.scss';

interface BlokProps {
	blok: OffertaPopUpButtonStoryblok;
}

const blokProps = ({ blok }: BlokProps): OffertaPopUpButtonProps => {
	const props: OffertaPopUpButtonProps = {
		buttonText: blok?.buttonText,
	};

	return props;
};

export interface OffertaPopUpButtonProps {
	buttonText: string;
	onClick?: () => void;
}

export const OffertaPopUpButton: Blok<OffertaPopUpButtonProps, BlokProps> = ({ buttonText, onClick }) => {
	// PIWIK IMPRESSION TRACKING
	const { CustomEvent } = usePiwikPro();
	const pathname = usePathname();
	const slug = getPiwikTrackingSlug(pathname);
	const category = 'Form - Leads|SQL';
	const action = 'form - submit';
	const name = `${slug}-offerta|popup`;

	const { setShowModal } = useOffertaModal();

	useEffect(() => {
		function formSubmitted() {
			CustomEvent.trackEvent(category, action, name);
		}
		const handleOffertaFormSubmitted = () => {
			formSubmitted();
		};
		window.addEventListener('handleIsDone', handleOffertaFormSubmitted as EventListener);
		return () => {
			window.removeEventListener('handleIsDone', handleOffertaFormSubmitted as EventListener);
		};
	}, [CustomEvent, name]);

	return (
		<Button
			className={styles.offertaButton}
			onClick={() => {
				onClick && onClick();
				setShowModal(true);
			}}
		>
			{buttonText}
		</Button>
	);
};

OffertaPopUpButton.blokProps = blokProps;
